import { render } from "./App.vue?vue&type=template&id=8a140272&bindings={\"currentlyPlaying\":\"data\",\"token\":\"data\",\"userIsPremium\":\"data\",\"paused\":\"data\",\"getCurrentlyPlaying\":\"options\",\"updatePlaying\":\"options\",\"prevSong\":\"options\",\"songPausePlay\":\"options\",\"nextSong\":\"options\",\"redirect\":\"options\",\"getUserInfo\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script